/** @jsxImportSource @emotion/react */
import { DesignTokensProvider } from '@context/DesignTokensContext'
import { useDesignTokens } from '@hooks/useDesignTokens'
import BookingPage from '@pages/BookingPage'
import CalendarAddPage from '@pages/CalendarAddPage'
import HomePage from '@pages/HomePage'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { TOKENS } from './gen/tokenConstants'

function AppContent() {
  const { getValue } = useDesignTokens()

  return (
    <div
      data-testid='app-root'
      css={{
        margin: 0,
        padding: 0,
        fontFamily: getValue(TOKENS.typography.fontFamily.primary),
        backgroundColor: getValue(TOKENS.color.neutral[50]),
        minHeight: '100vh',
        '*, *::before, *::after': {
          boxSizing: 'border-box',
        },
      }}
    >
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/book/:calendarId' element={<BookingPage />} />
            <Route path='/calendar/add' element={<CalendarAddPage />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  )
}

export function App() {
  return (
    <DesignTokensProvider>
      <AppContent />
    </DesignTokensProvider>
  )
}
